import * as React from 'react';
import { CrumbWidget } from '../../widgets/CrumbWidget';
import { ContentWidget } from '../../widgets/ContentWidget';
import { PageWidget } from '../../widgets/layout/PageWidget';
import { SectionWidget } from '../../widgets/layout/SectionWidget';
import { Documents } from '../../RoutesWidget';

const image = require('../../../media/elementor-placeholder-image.png');
const image_opsql = require('../../../media/stack/opsql.png');

export const OpSQLPage: React.FC = () => {
  return (
    <PageWidget title="OPSQL">
      <ContentWidget>
        <h1>
          <CrumbWidget parts={['Platform stack', 'OPSQL']} />
        </h1>
        <img src={image_opsql} />
        <p>
          OPSQL (Oplog-SQL) is a JourneyApps Platform feature which allows developers to query their data directly via a
          SQL database. Data in the JourneyApps Platform (while structured) is inherently no-sql. When it comes to
          reporting however (or any kind of BI requirements), its often much easier and preferred to work with relation
          databases.
        </p>
        <p>
          <b>That's where OPSQL Comes in</b>. With OPSQL developers can with a push of a button, spin up a SQL database
          with an OPSQL replicator that uses the JourneyApps Platform Operation Log to replicate an application database
          fully and directly into a cloud SQL database.
        </p>
        <p>
          OPSQL is a fully automatic and managed system. Unlike competing products in this space which require
          developers to maintain the SQL schema themselves, OPSQL handles this automatically and even sets up indexes to
          keep querying data as performant as possible.
        </p>
        <SectionWidget
          image={image}
          label={'It just works right out the box'}
          content="OPSQL in its default mode, is designed to just simply work without any developer configuration, database tuning or SQL administration.
          Because OPSQL uses the same database schema used in the App Backends, OPSQL already has all the information it needs to set up indexes and column types correctly."
          index={1}
        ></SectionWidget>
        <SectionWidget
          image={image}
          ltr={false}
          label={'Good defaults, but also highly configurable'}
          content="OPSQL has configuration that can also allow it operate in more advanced configurations. Need multiple app databases in the same SQL DB but namespaced with different SQL schemas? Need to force all column types into text? Need to exclude select fields or models entirely? No problem."
          index={2}
        ></SectionWidget>
        <SectionWidget
          image={image}
          label={'Managed databases or bring your own'}
          content="By default, OPSQL will handle the provisionin of databases directly with cloud providers, but developers can just as easilly bring their own databases. This allows developers
          to manage their own infrastructure and scale their databse as needed in more demanding environments where performance and/or data security is the highest priority."
          index={3}
        ></SectionWidget>
        <h2>OPSQL is the missing link for low-code platforms that want to take their apps to the next level.</h2>
        <p>
          For more information, take a look at the white-paper: <a href={Documents.OPSQL}>Click here to download.</a>
        </p>
      </ContentWidget>
    </PageWidget>
  );
};
